import { Store } from 'redux';
import { ReduxAxiosRequestConfig } from 'redux-axios-middleware';
import { RootState } from 'store/types';
import { currentAccountConsumerSelector } from 'store/account/selectors';
import * as notificationsSelectors from '../notifications/selectors';

export const hipaaPatientIdInterceptor = (
  { getState }: Store<RootState>,
  config: ReduxAxiosRequestConfig
) => {
  const patientId = notificationsSelectors.notificationsHipaaPatientIdSelector(getState());
  const { consumerId } = currentAccountConsumerSelector(getState());

  const hipaaResourceMatcher = /\/hipaa/;
  if (
    config.reduxSourceAction.payload.client === 'dispatcher' &&
    patientId &&
    consumerId &&
    hipaaResourceMatcher.test(config.reduxSourceAction.payload.url)
  ) {
    // eslint-disable-next-line no-param-reassign
    config.headers = {
      'x-patient-id': patientId,
      'x-dfd-consumer-id': consumerId,
      ...config.headers
    };
  }

  return config;
};
